type CustomerMsg = {
  language: string;
  content: string;
};

type ErrorResponse = {
  raw: string;
  providerErrorCode?: string;
  mappedErrorCode?: string;
  devMsg?: string;
  severity?: string;
  customerMsg?: CustomerMsg[];
};

export function getErrorMessage(
  error: ErrorResponse,
  language: string = "en"
): string {
  if (error?.customerMsg && error?.customerMsg?.length > 0) {
    const msg = error.customerMsg.find(
      errObj => errObj.language.toLowerCase() === language.toLowerCase()
    );
    if (msg) return msg.content;
  }

  if (error?.devMsg) {
    return error.devMsg;
  }

  return error?.raw || "Unknown error occurred";
}
